module.exports = __webpack_public_path__ + "img/coin-line.5b871ba8.svg";